import {Component} from '@angular/core'
import {LogoComponent, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  imports: [
    LogoComponent,
    ToggleButtonComponent
  ],
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

}
